
















































import { defineComponent, ref, PropType } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { categoryHeadersData } from '@/bundles/Category/helpers';
import { Nullable } from '@/bundles/App/type';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import UpsertCategory from '@/bundles/Category/components/UpsertCategory.vue';
import { ICategory } from '@/bundles/Category/interfaces';

export default defineComponent({
  name: 'CategoryListTable',

  components: { UpsertCategory, BaseTable },

  props: {
    tableOptionsEntry: {
      type: Object as PropType<ITableOptions>,
      required: true
    },
    itemsEntry: {
      type: Array as PropType<Array<ICategory>>,
      default: () => []
    },
    totalRowsEntry: {
      type: Number,
      default: 0
    },
    loading: Boolean
  },

  emits: ['options:change', 'items:refresh', 'updateCategory', 'addCategory'],

  setup(props, { emit }) {
    function calculateHeight() {
      const total = window.innerHeight;
      const header = document.querySelector('.v-app-bar--fixed');
      const elementsHeight = (header as HTMLElement)?.offsetHeight + 64;
      // @ts-ignore
      return total - elementsHeight - (this.$vuetify.breakpoint.xs ? -55 : 0);
    }

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    const showCategoryModal = ref(false);
    const isEdit = ref(false);
    const selectedCategory = ref<Nullable<object>>(null);

    function toggleDrawerEventHandler(id: string | number) {
      isEdit.value = id !== 'create';
      showCategoryModal.value = true;

      if (id === 'create') {
        selectedCategory.value = {};
        return;
      }

      const category = props.itemsEntry.find(category => {
        return category.id === id;
      });

      selectedCategory.value = Object.assign({}, category);
    }

    return {
      calculateHeight,
      optionsChangeEventHandler,
      toggleDrawerEventHandler,
      showCategoryModal,
      isEdit,
      selectedCategory,
      categoryHeadersData
    };
  }
});
